import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
export const defaultAuthorizationPersonas = {
    'US Planner': {
        authorization: {
            metadata: {
                LocaleId: 1033,
                locale: 'en-US'
            }
        }
    },
    'French Planner': {
        authorization: {
            metadata: {
                LocaleId: 1036,
                locale: 'fr-FR'
            }
        }
    }
};
const setItem = (key, value) => {
    if (typeof window !== 'undefined') {
        if (key) {
            try {
                localStorage.setItem(key, value);
            }
            catch (e) {
                // Fall back to sessionStorage if localStorage not supported
                /* istanbul ignore next */
                sessionStorage.setItem(key, value);
            }
        }
    }
};
const getItem = (key) => {
    if (typeof window !== 'undefined') {
        try {
            return localStorage.getItem(key);
        }
        catch (e) {
            // Fall back to sessionStorage if localStorage not supported
            /* istanbul ignore next */
            return sessionStorage.getItem(key);
        }
    }
    /* istanbul ignore next */
    return null;
};
const validateToken = (tokenString) => {
    try {
        JSON.parse(tokenString);
        return { text: '', type: 'info' };
    }
    catch (error) {
        /* istanbul ignore next */
        return { text: `Access token options must be JSON ${error.message}`, type: 'error' };
    }
};
const getPersonas = () => {
    const personas = getItem('tokenOptions');
    if (personas) {
        const { type } = validateToken(personas);
        if (type !== 'error') {
            return JSON.parse(personas);
        }
    }
    return defaultAuthorizationPersonas;
};
const styles = {
    select: { padding: '0.5rem' },
    layout: { margin: 'auto', width: 500 },
    form: { display: 'flex', flexDirection: 'column', gap: '1rem' },
    buttonRow: { display: 'flex', gap: '0.5rem', justifyContent: 'space-between' },
    formRow: { display: 'flex', flexDirection: 'column' },
    button: {
        flex: 'auto',
        padding: '0.5rem',
        borderRadius: '0.4rem',
        cursor: 'pointer',
        boxShadow: '0.25rem 0.25rem 0.5rem #efefef',
        borderWidth: '1px'
    }
};
export function DevLoginForm({ initialPersonas = getPersonas(), login }) {
    const [personas, setPersonas] = useState(initialPersonas);
    const [personaName, setPersonaSelection] = useState(String(Object.keys(personas)[0]));
    const [tokenOptions, setTokenOptions] = useState(JSON.stringify(personas[personaName], null, 2));
    const [tokenError, setTokenError] = useState(null);
    const onPersonaChange = useCallback((event) => {
        const selection = event.target.value;
        setPersonaSelection(selection);
        setTokenOptions(JSON.stringify(personas[selection], null, 2));
    }, [personas]);
    const onAuthMetadataChange = (event) => {
        setTokenOptions(event.target.value);
    };
    const validateAuthMetadata = (event) => {
        const { text, type } = validateToken(event.target.value);
        setTokenError(type === 'error' ? text : null);
    };
    const onSubmit = useCallback((evt) => {
        evt.preventDefault();
        if (validateToken(tokenOptions).type !== 'error') {
            login(JSON.parse(tokenOptions));
        }
    }, [login, tokenOptions]);
    const updateTokenOptions = () => {
        const updatedPersona = {};
        /* istanbul ignore if */
        if (validateToken(tokenOptions).type === 'error') {
            return;
        }
        updatedPersona[personaName] = JSON.parse(tokenOptions);
        setItem('tokenOptions', JSON.stringify({ ...personas, ...updatedPersona }));
        setPersonas({ ...personas, ...updatedPersona });
    };
    const createTokenOptions = () => {
        // eslint-disable-next-line no-alert
        const name = prompt('Please enter persona name');
        const persona = {};
        if (name) {
            persona[name] = {};
            const newAuthorizationPersonas = { ...personas, ...persona };
            setPersonas(newAuthorizationPersonas);
            setPersonaSelection(name);
            setTokenOptions(JSON.stringify({}, null, 2));
            setItem('tokenOptions', JSON.stringify({ ...personas, ...persona }));
        }
    };
    const resetTokenOptions = () => {
        const [persona] = Object.keys(personas);
        setPersonas(defaultAuthorizationPersonas);
        setPersonaSelection(String(persona));
        setTokenOptions(JSON.stringify(personas[String(persona)], null, 2));
        setItem('tokenOptions', '');
        setTokenError(null);
    };
    return (_jsxs("div", { style: styles.layout, children: [_jsx("h3", { children: "Developer Login" }), _jsx("p", { children: "This form is intended to be used in local development or in lower regions deployments internal to Cvent's network. Once a product has a real log in process configure this control only for local development. Personas can be created and saved to local browser storage. To reset to project default use the reset button." }), _jsxs("div", { style: styles.form, children: [_jsxs("label", { htmlFor: "personaDropdown", style: styles.formRow, children: ["Persona", _jsx("select", { id: "personaDropdown", style: { padding: '0.5rem' }, onChange: onPersonaChange, value: personaName, children: Object.keys(personas).map((name) => (_jsx("option", { value: name, children: name }, name))) })] }), _jsxs("label", { htmlFor: "authOptions", style: styles.formRow, children: ["Authorization Metadata", _jsx("textarea", { id: "authOptions", rows: 8, style: { padding: '0.5rem', ...(tokenError && { border: '1px solid red' }) }, onChange: onAuthMetadataChange, onBlur: validateAuthMetadata, value: tokenOptions }), tokenError && _jsx("div", { style: { color: 'red' }, children: tokenError })] }), _jsxs("div", { style: styles.buttonRow, children: [_jsx("button", { type: "button", style: styles.button, onClick: createTokenOptions, children: "Create" }), _jsx("button", { type: "button", style: styles.button, onClick: updateTokenOptions, children: "Update" }), _jsx("button", { type: "button", style: styles.button, onClick: resetTokenOptions, children: "Reset" }), _jsx("button", { type: "button", style: styles.button, onClick: onSubmit, children: "Submit" })] })] })] }));
}
//# sourceMappingURL=DevLoginForm.js.map